import {
  Edit,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "@/components/admin"
import { ReactElement } from "react"

const ContractEdit = (): ReactElement => {
  return (
    <Edit redirect="list" title="" actions={false}>
      <SimpleForm>
        <ReferenceInput reference="roles" source="user_role">
          <SelectInput />
        </ReferenceInput>
        <TextInput label="Nom d'utilisateur" source="username" />
      </SimpleForm>
    </Edit>
  )
}

export default ContractEdit
